import { render, staticRenderFns } from "./ownerInvoiceList.vue?vue&type=template&id=5973c6af&scoped=true"
import script from "./ownerInvoiceList.vue?vue&type=script&lang=js"
export * from "./ownerInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./ownerInvoiceList.vue?vue&type=style&index=0&id=5973c6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973c6af",
  null
  
)

export default component.exports